import {
    required,
    email,
    minLength,
    maxLength,
    requiredIf
} from 'vuelidate/lib/validators';
import abstractValidatorMixin from '../abstractValidator.mixin';

export default {
    mixins: [abstractValidatorMixin],
    data() {
        return {
            serverErrors: {
                firstName: [],
                lastName: [],
                birthDate: [],
                phone: [],
                email: [],
                password: []
            }
        };
    },
    validations: {
        formData: {
            firstName: { required },
            lastName: { required },
            birthDate: { required },
            phone: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(255)
            },
            email: { required, email },
            password: {
                required: requiredIf(function() {
                    return !this.formData.isPasswordOptionChecked && !this.user;
                }),
                minLength: minLength(6),
                maxLength: maxLength(255)
            }
        }
    },
    computed: {
        firstNameErrors() {
            return this.checkErrors('firstName');
        },
        lastNameErrors() {
            return this.checkErrors('lastName');
        },
        birthDateErrors() {
            return this.checkErrors('birthDate');
        },
        phoneErrors() {
            return this.checkErrors('phone');
        },
        emailErrors() {
            return this.checkErrors('email');
        },
        passwordErrors() {
            return this.checkErrors('password');
        }
    }
};
